import { IContactInitialContext } from '../types';
import { DEFAULT_CONTACT_STATE } from './defaultState';

export const DEFAULT_CONTACT_CONTEXT: IContactInitialContext = {
    ...DEFAULT_CONTACT_STATE,
    clearState: () => {},
    setLoading: () => {},
    createContact: async () => undefined,
    searchContactsByFilters: async () => undefined,
    getContact: async () => undefined,
    updateContact: async () => undefined,
    bulkDeleteContacts: async () => undefined,
    clearContact: () => {},
};
